import * as React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Table from 'react-bootstrap/Table';
import { RoleType } from '../../pages/admin/RoleManagement';
import RoleRow from './RoleRow';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios';
import { qsStringify, exportAsCsv } from '../../utilities/helper';
import AxiosConfig from '../../utilities/AxiosConfig';
import Loader from '../common/Loader';
import "./ConfigureRoles.css"

export interface ConfigureRolesProps {

}

export interface ConfigureRolesState {
    addRoleOpen: boolean,
    newRole: {
        RoleName: string,
        Description: string,
        RoleCategory: string,
        MapToLPRoleCsv: string,
        isProtected: boolean,
    },
    errorVisible: boolean,
    errorMessage: string,
    roles: Array<RoleType>,
    loadingRoles: boolean,
    isSendingRoles: boolean,
}

class ConfigureRoles extends React.Component<ConfigureRolesProps, ConfigureRolesState> {
    constructor(props: ConfigureRolesProps) {
        super(props);
        this.state = {
            addRoleOpen: false,
            newRole: {
                RoleName: "",
                Description: "",
                RoleCategory: "",
                MapToLPRoleCsv: "",
                isProtected: true,
            },
            errorVisible: false,
            errorMessage: "",
            roles: [],
            loadingRoles: true,
            isSendingRoles: false,
        }
    }

    componentDidMount() {
        this.setState({ loadingRoles: true })
        axios.get(process.env.REACT_APP_API_URL + '/api/portal/role/*', AxiosConfig.configValue())
            .then(res => {
                //console.log(res, res.data);
                if (res.status === 200) {
                    this.setState({ roles: res.data });
                }
                this.setState({ loadingRoles: false });
            })
            .catch(err => {
                //console.log(err);
                this.setState({ loadingRoles: false });
                AxiosConfig.handleError(err);
            })
    }

    toggleModal = (e?: React.SyntheticEvent) => {
        e && e.preventDefault();
        this.setState({ addRoleOpen: !this.state.addRoleOpen });
    }

    addRole = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const { RoleName } = this.state.newRole;
        if (RoleName) {
            this.setState({ isSendingRoles: true })
            const config = AxiosConfig.configValue();
            const requestBody = qsStringify(this.state.newRole);
            axios.post(process.env.REACT_APP_API_URL + '/api/portal/role', requestBody, config)
                .then(res => {
                    if (res.data) {
                        let newRole = { ...this.state.newRole }
                        let final: RoleType = {
                            PortalRoleId: res.data,
                            RoleName: newRole.RoleName,
                            Description: newRole.Description,
                            RoleCategory: newRole.RoleCategory,
                            MapToLPRoleCsv: newRole.MapToLPRoleCsv,
                            IsProtected: newRole.isProtected,
                            DeletedDate: "",
                            DeletedBy: "",
                            DisabledDate: "",
                            DisabledBy: "",
                            CreatedDate: Date.now().toString(),
                            CreatedBy: "LPPortal",
                            ModifyDate: "",
                            ModifiedBy: ""
                        };
                        this.setState({
                            errorVisible: false,
                            addRoleOpen: false,
                            roles: [...this.state.roles, final],
                        });
                    }
                })
                .catch(err => {
                    //console.log(err.response);
                    this.setState({ errorVisible: true, errorMessage: err.response.data.message });
                    AxiosConfig.handleError(err);
                })
                .finally(() => {
                    this.setState({
                        newRole: {
                            RoleName: "",
                            Description: "",
                            RoleCategory: "",
                            MapToLPRoleCsv: "",
                            isProtected: true,
                        },
                        isSendingRoles: false,
                    })
                })
        } else {
            this.setState({ errorVisible: true, errorMessage: "Please enter a role name" });
        }

    }

    changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            newRole: {
                ...this.state.newRole, [e.target.name]: e.target.value
            }
        })
        //console.log(this.state.newRole);
    }

    toggleCheck = (): void => {
        this.setState({ newRole: { ...this.state.newRole, isProtected: !this.state.newRole.isProtected } })
    }

    deleteRole = (role: RoleType) => {
        let copy = [...this.state.roles];
        copy.splice(copy.indexOf(role), 1);
        this.setState({ roles: copy });
    }

    exportCsv = () => {
        exportAsCsv(
            [
                "ID",
                "Name",
                "Description",
                "Category",
                "Protected",
                "Created At",
                "Created By",
                "Last Modified",
                "Modified By",
            ],
            [
                "PortalRoleId",
                "RoleName",
                "Description",
                "RoleCategory",
                "IsProtected",
                "CreatedDate",
                "CreatedBy",
                "ModifyDate",
                "ModifiedBy",
            ],
            this.state.roles,
            "roles"
        )
    }

    editCB = (index: number, edits: RoleType) => {
        //console.log("Callback for edits.");
        let copy = [...this.state.roles];
        copy[index] = edits;
        this.setState({ roles: copy });
        //console.log("new state", copy);
    }

    render() {
        const { addRoleOpen, newRole, errorMessage, errorVisible, roles, loadingRoles, isSendingRoles } = this.state;
        if (loadingRoles) {
            return <Loader title="Loading Roles..." />;
        }
        return (
            <div className="ConfigureRoles">
                <Table bordered hover size="sm" responsive="md">
                    <thead id="configure-roles-header">
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>Protected</th>
                            <th>Created At</th>
                            <th>Created By</th>
                            <th>Last Modified</th>
                            <th>Modified By</th>
                            <th className="d-flex flex-row justify-content-end">
                                <ButtonGroup>
                                    <Button onClick={this.toggleModal}>
                                        <i className="material-icons flex-0">add</i>
                                    </Button>
                                    <Button variant="info" onClick={this.exportCsv}>
                                        <i className="material-icons flex-0">file_copy</i>
                                    </Button>
                                </ButtonGroup>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            roles.map((role, index) => <RoleRow index={index} editCB={this.editCB} deleteCB={() => this.deleteRole(role)} key={role.PortalRoleId} role={role} />)
                        }
                    </tbody>
                </Table>

                <Modal show={addRoleOpen} onHide={this.toggleModal} className="z-100">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Role</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            errorVisible &&
                            <Alert variant="danger" onClose={() => this.setState({ errorVisible: false })} dismissible>
                                <p>{errorMessage}</p>
                            </Alert>
                        }
                        <Form>
                            <Form.Group controlId="formGroupName">
                                <Form.Label>Role Name</Form.Label>
                                <Form.Control onChange={this.changeHandler} name="RoleName" type="text" placeholder="Name" />
                            </Form.Group>
                            <Form.Group controlId="formGroupDescription">
                                <Form.Label>Description</Form.Label>
                                <Form.Control onChange={this.changeHandler} name="Description" type="text" placeholder="Description" />
                            </Form.Group>
                            <Form.Group controlId="formGroupCategory">
                                <Form.Label>Category</Form.Label>
                                <Form.Control onChange={this.changeHandler} name="RoleCategory" type="text" placeholder="Category" />
                            </Form.Group>
                            <Form.Group controlId="formGroupMapToLPRole">
                                <Form.Label>Map To LP Role</Form.Label>
                                <Form.Control onChange={this.changeHandler} name="MapToLPRoleCsv" type="text" placeholder="Map To LP Role" />
                            </Form.Group>
                            <Form.Check type="checkbox" id="isProtectedCheck">
                                <Form.Check.Input onChange={this.toggleCheck} type="checkbox" checked={newRole.isProtected} />
                                <Form.Check.Label>Is Protected</Form.Check.Label>
                            </Form.Check>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" disabled={isSendingRoles} onClick={this.toggleModal}>
                            Close
                        </Button>
                        <Button variant="primary" disabled={isSendingRoles} onClick={this.addRole}>
                            Create Role
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default ConfigureRoles;